<template>
  <div class="text-xs-center">
    <v-menu
      v-model="menu"
      max-width="800"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      lazy
    >
      <template #activator="{ on }">
        <v-btn flat icon v-on="on">
          <v-icon>tune</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-layout wrap row pa-3>
          <v-flex xs12 md4 px-2>
            <v-select
              v-model="localFilters.type"
              :items="matchTypes"
              :readonly="tournamentView"
              :clearable="!tournamentView"
              :label="$t('fields.global.type')"
              @change="onChangeType"
            />
          </v-flex>
          <v-flex v-if="localFilters.type !== 'tournament'" xs12 md8 px-2>
            <category-menu
              v-model="localFilters.categoryId"
              clearable
              :label="$tc('models.category')"
            />
          </v-flex>
          <v-flex v-else-if="localFilters.type === 'tournament'" xs12 md8 px-2>
            <tournament-field
              v-model="localFilters.tournamentId"
              :label="$tc('models.tournament')"
              :readonly="tournamentView"
              :clearable="!tournamentView"
            />
          </v-flex>
          <v-flex xs12>
            <v-layout wrap row>
              <v-flex v-if="localFilters.categoryId" md4 xs12 px-2>
                <v-text-field
                  v-model="localFilters.session"
                  type="number"
                  :label="$tc('fields.matches.session')"
                />
              </v-flex>
              <v-flex xs12 md8 px-2>
                <entity-field
                  v-model="localFilters.entityId"
                  :tournament-id="localFilters.tournamentId"
                  :is-customer="localFilters.isCustomer"
                  :label="$tc('models.entity')"
                  filter-data
                  @change="(val) => (localFilters.playAs = 'all')"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-if="localFilters.entityId" xs12 px-3>
            <label class="v-label">{{ $t('titles.global.playAs') }}</label>
            <v-radio-group
              v-model="localFilters.playAs"
              :column="false"
              class="mt-1 mb-0"
            >
              <v-radio
                value="home"
                :label="$t('fields.matches.homeTeam')"
                color="primary"
              />
              <v-radio
                value="visitor"
                :label="$t('fields.matches.visitorTeam')"
                color="primary"
              />
              <v-radio
                value="all"
                :label="$t('action.buttons.all')"
                color="primary"
              />
            </v-radio-group>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap row>
              <v-flex xs12 px-2>
                <team-field
                  ref="homeTeam"
                  v-model="localFilters.homeTeamId"
                  :entity-id="localFilters.entityId"
                  :category-id="localFilters.categoryId"
                  :tournament-id="localFilters.tournamentId"
                  :is-customer="localFilters.isCustomer"
                  :label="$t('fields.matches.homeTeam')"
                  :all="isOwnTeam('visitorTeam', localFilters.visitorTeamId)"
                />
              </v-flex>
              <v-flex xs12 px-2>
                <team-field
                  ref="visitorTeam"
                  v-model="localFilters.visitorTeamId"
                  :entity-id="localFilters.entityId"
                  :tournament-id="localFilters.tournamentId"
                  :category-id="
                    localFilters.type === 'league'
                      ? localFilters.categoryId
                      : ''
                  "
                  :is-customer="localFilters.isCustomer"
                  :label="$t('fields.matches.visitorTeam')"
                  :all="isOwnTeam('homeTeam', localFilters.homeTeamId)"
                />
              </v-flex>

              <!-- Filtro Campo -->
              <v-flex xs12 :md6="!localFilters.isCustomer" px-3>
                <pitch-field
                  v-model="localFilters.location"
                  :tournament-id="localFilters.tournamentId"
                  :entity-id="localFilters.entityId"
                  :team-id="localFilters.homeTeamId"
                  :label="$t('fields.global.location')"
                />
              </v-flex>
              <!-- Filtro Campo -->
              <template v-if="isAdmin">
                <v-flex xs12 md2 px-3>
                  <v-checkbox
                    v-model="localFilters.isCustomer"
                    :label="$t('titles.entities.client')"
                    color="primary"
                    @change="onChangeIsCustomer"
                  />
                </v-flex>
                <v-flex v-if="localFilters.isCustomer" xs12 md8 px-3>
                  <label class="v-label">{{
                    $t('titles.global.playAs')
                  }}</label>
                  <v-radio-group
                    v-model="localFilters.playAs"
                    :column="false"
                    class="mt-1 mb-0"
                  >
                    <v-radio
                      value="home"
                      :label="$t('fields.matches.homeTeam')"
                      color="primary"
                    />
                    <v-radio
                      value="visitor"
                      :label="$t('fields.matches.visitorTeam')"
                      color="primary"
                    />
                    <v-radio
                      value="all"
                      :label="$t('action.buttons.all')"
                      color="primary"
                    />
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md3>
                  <v-checkbox
                    v-model="localFilters.emissionStatus"
                    :label="$t('fields.matches.emissionStatus')"
                    color="primary"
                  />
                </v-flex>
              </template>
            </v-layout>
          </v-flex>

          <!-- Filtro fechas -->
          <v-flex xs12>
            <v-layout wrap row>
              <v-flex xs12 md6 px-2>
                <date-picker
                  v-model="localFilters.dateStart"
                  :label="$t('fields.tournaments.startAt')"
                />
              </v-flex>

              <v-flex xs12 md6 px-2>
                <date-picker
                  v-model="localFilters.dateEnd"
                  :label="$t('fields.tournaments.endAt')"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider />
        <v-card-actions>
          <v-spacer />

          <v-btn
            color="primary"
            flat
            :loading="$store.state.matches.loading"
            @click="search"
          >
            {{ $t('action.buttons.search') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

import CategoryMenu from '@/components/management/categories/CategoryMenu'
import DatePicker from '@/components/widgets/Input/DatePicker'
import EntityField from '@/components/widgets/Input/EntityField'
import PitchField from '@/components/widgets/Input/PitchField'
import TeamField from '@/components/widgets/Input/TeamField'
import TournamentField from '@/components/widgets/Input/TournamentField'

export default {
  name: 'MatchFilters',
  components: {
    CategoryMenu,
    TeamField,
    EntityField,
    TournamentField,
    PitchField,
    DatePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    tournamentView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    menu: false,
  }),
  watch: {
    tournamentId(val) {
      if (val && this.tournamentView) {
        this.localFilters.tournamentId = val
        this.localFilters.type = 'tournament'
      }
    },
  },
  computed: {
    ...mapState({
      tournamentId: (state) => state.tournaments.idSelected,
    }),
    ...mapGetters({
      matchTypes: 'matches/matchTypes',
    }),
    localFilters: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    search() {
      this.menu = false
      this.$emit('search')
    },
    onChangeType(val) {
      if (val === 'tournament') this.localFilters.categoryId = ''
      else this.localFilters.tournamentId = ''
    },
    onChangeIsCustomer(val) {
      if (!val && !this.localFilters.entityId) {
        this.localFilters.playAs = 'all'
      }
    },
    isOwnTeam(type, teamId) {
      if (
        this.isAdmin ||
        (this.localFilters.tournamentId &&
          this.is('coordinatorTournament', this.localFilters.tournamentId))
      )
        return true

      let hasRole = teamId && this.is('trainer', teamId)
      if (!hasRole && this.$refs[type]) {
        hasRole = this.$refs[type].itemList.some(
          (item) =>
            item.value === teamId &&
            this.is(['president', 'coordinator'], item.entityId)
        )
      }
      return hasRole
    },
  },
}
</script>
<style scoped lang="scss">
.v-input--selection-controls.v-input .v-label {
  margin-right: 50px !important;
}
</style>
